import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useEffect, useMemo, useState } from 'react';
import { flattenTree, getAllParentIds } from 'utils/tree';
import useLocalStorage from 'hooks/useLocalStorage';
// Convert the openSectionIds object to an array of section ids
// e.g. {1: true, 2: false, 3: true} => [1, 3]
function getOpenSectionIds(openSectionMap) {
  var arr = [];
  for (var key in openSectionMap) {
    if (openSectionMap[key] === true) {
      arr.push(key);
    }
  }
  return arr;
}
var calculateOpenMap = function calculateOpenMap(_ref) {
  var allChildren = _ref.allChildren,
    openSectionIds = _ref.openSectionIds,
    defaultSectionState = _ref.defaultSectionState;
  var shouldSectionOpen = function shouldSectionOpen(id) {
    if (defaultSectionState === 'open') {
      return true; // open all sections in preview mode or when the playlist is short
    }

    return openSectionIds.includes(id);
  };
  var openMap = {};
  allChildren.forEach(function (content) {
    if (content.type === 'section') {
      openMap[content.id] = shouldSectionOpen(content.id);
    }
  });
  return openMap;
};
function useOpenSection(_ref2) {
  var isPreviewMode = _ref2.isPreviewMode,
    defaultSectionState = _ref2.defaultSectionState,
    playlistContent = _ref2.playlistContent,
    _ref2$linkedAssetId = _ref2.linkedAssetId,
    linkedAssetId = _ref2$linkedAssetId === void 0 ? null : _ref2$linkedAssetId;
  // 1. find the first incomplete item
  var allChildren = useMemo(function () {
    return flattenTree(playlistContent);
  }, [playlistContent]);
  var firstIncompleteItem = useMemo(function () {
    return allChildren.find(function (item) {
      return item.type !== 'section' && item.userContentStatus !== 'completed';
    });
  }, [allChildren]);
  // 2. Store the ids of the first incomplete section and subsection in an array
  var firstIncompleteSectionIds = useMemo(function () {
    return getAllParentIds(allChildren, firstIncompleteItem);
  }, [allChildren, firstIncompleteItem]);

  // if the linkedAssetId is provided, open the section containing the asset
  var targetSectionIds;
  if (linkedAssetId) {
    var targetAsset = allChildren.find(function (item) {
      return item.id === +linkedAssetId;
    });
    targetSectionIds = getAllParentIds(allChildren, targetAsset);
  }

  // Store a section's open/close state in local storage by its id when it is toggled manually
  var _useLocalStorage = useLocalStorage('openedSectionId', {}),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
    userSectionOpenMap = _useLocalStorage2[0],
    setUserSectionOpenMap = _useLocalStorage2[1];
  var _useState = useState(function () {
      return calculateOpenMap({
        allChildren: allChildren,
        openSectionIds: linkedAssetId ? targetSectionIds.concat(firstIncompleteSectionIds) : userSectionOpenMap ? getOpenSectionIds(userSectionOpenMap) : firstIncompleteSectionIds,
        defaultSectionState: defaultSectionState
      });
    }),
    _useState2 = _slicedToArray(_useState, 2),
    defaultSectionOpenMap = _useState2[0],
    setDefaultSectionOpenMap = _useState2[1];
  var sectionOpenMap = isPreviewMode ? defaultSectionOpenMap : _objectSpread(_objectSpread({}, defaultSectionOpenMap), userSectionOpenMap);

  // Once the user completes the last asset/playlist of a section,
  // the next incomplete section will be opened
  useEffect(function () {
    setDefaultSectionOpenMap(function (oldMap) {
      var newMap = _objectSpread({}, oldMap);
      var hasChanged = false;
      firstIncompleteSectionIds.forEach(function (id) {
        if (id && newMap[id] !== true) {
          // if the section is closed but it's the next incomplete section, open it
          newMap[id] = true;
          // ensure the next incomplete section is opened, even if it's set manually to be closed in the local storage
          var newCachedMap = _objectSpread({}, userSectionOpenMap);
          delete newCachedMap[id];
          setUserSectionOpenMap(newCachedMap);
          hasChanged = true;
        }
      });
      return hasChanged ? newMap : oldMap;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstIncompleteSectionIds]);
  function getIsOpen(sectionId) {
    return sectionOpenMap[sectionId];
  }
  function toggleIsOpen(sectionId) {
    isPreviewMode ? setDefaultSectionOpenMap(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, sectionId, !prev[sectionId]));
    }) : setUserSectionOpenMap(_objectSpread(_objectSpread({}, userSectionOpenMap), {}, _defineProperty({}, sectionId, !sectionOpenMap[sectionId])));
  }
  return {
    getIsOpen: getIsOpen,
    toggleIsOpen: toggleIsOpen
  };
}
export default useOpenSection;